import { PropsWithChildren, createContext, useContext, useState } from 'react'

type UploadsTabPanel =
  | { panel: 'default'; panelProps: {} }
  | { panel: 'uploads'; panelProps: {} }
  | { panel: 'videos'; panelProps: {} }
  | { panel: 'photos'; panelProps: {} }
  | { panel: 'brandKit'; panelProps: { title: string; brandKitId: number } }
  | { panel: 'shapes'; panelProps: {} }
  | { panel: 'masks'; panelProps: {} }
  | { panel: 'icons'; panelProps: {} }

export const UploadsTabContext = createContext<
  UploadsTabPanel & {
    openPanel: (panel: UploadsTabPanel) => void
    closePanel: () => void
    forBackground?: boolean
  }
>({
  panel: 'default',
  panelProps: {},
  openPanel: () => {},
  closePanel: () => {},
  forBackground: false,
})

export const useUploadsTab = () => {
  const context = useContext(UploadsTabContext)

  if (!context) {
    throw new Error(`useUploadsTab must be within UploadsTabContext.Provider`)
  }

  return context
}

export const UploadsTabProvider = (props: PropsWithChildren<{ forBackground?: boolean }>) => {
  const [panel, setPanel] = useState<UploadsTabPanel>({ panel: 'default', panelProps: {} })

  const closePanel = () => {
    setPanel({ panel: 'default', panelProps: {} })
  }

  return (
    <UploadsTabContext.Provider
      value={{
        ...panel,
        openPanel: setPanel,
        closePanel,
        forBackground: props.forBackground,
      }}
    >
      {props.children}
    </UploadsTabContext.Provider>
  )
}
